import axios from 'axios';
import { ParamGetClients } from 'types/clients';
import * as qs from 'qs';
export const getClients = async (params: Partial<ParamGetClients>) => {
  const query = qs.stringify({
    ...params
  });
  const { data } = await axios.get(`/clients?${query}`);
  return data;
};
type clientPayload = {
  clientName: string;
  clientEmail: string;
  contactPerson: string;
};
export const createClient = async (payload: clientPayload) => {
  const { data } = await axios.post(`/clients?`, payload);
  return data;
};
export const updateClient = async (id: string, payload: clientPayload) => {
  const { data } = await axios.put(`/clients/${id}`, payload);
  return data;
};

export const archiveClient = async (id: number, payload: { isArchive: boolean }) => {
  const { data } = await axios.put(`/clients/${id}/archive`, payload);
  return data;
};

export const deleteClient = async (id: number) => {
  const { data } = await axios.delete(`/clients/${id}`);
  return data;
};

export const deleteLocation = async (id: number) => {
  const { data } = await axios.delete(`/locations/${id}`);
  return data;
};
